import { render, staticRenderFns } from "./SetUpProfileOverlay.vue?vue&type=template&id=72256af1&"
import script from "./SetUpProfileOverlay.vue?vue&type=script&lang=js&"
export * from "./SetUpProfileOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports